export default __webpack_public_path__ + "static/media/about-us.16947630.jpg";